import services from '../services'
import * as types from './mutation-types'

export const getAll = ({ commit }, params) => (
  services.list(params).then(res => {
    commit(types.SET_FOLLOW_UP_RULES, res.data)
  })
)

export const show = async ({ commit }, id) => {
  await services.show(id).then(res => {
    commit(types.SET_FOLLOW_UP_RULE, res.data.data)
  })
}

export const save = async ({ commit }, obj) => {
  await services.saveItem(obj).then(res => {
    commit(types.SET_FOLLOW_UP_RULE, res.data.data)
    return res
  })
}

export const deleteRule = async ({ commit }, id) => {
  await services.deleteRule(id).then(res => {
    return res
  })
}

export const changeStatus = async ({ commit }, id) => {
  await services.changeStatus(id).then(res => {
    return res
  })
}
